import ReactDOM from "react-dom/client";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import Router from "./Router";
import { CategoryProvider } from "./context/CategoryContext";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <CategoryProvider>
    <RouterProvider router={Router} />
  </CategoryProvider>
);
